import React from "react";
import NFLookupEmptyForms from "../../../Shared/NewForms/NFLookupEmptyForms";

function ReturnOfGoodsFromVendorsGenericSkeleton() {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
}

export default ReturnOfGoodsFromVendorsGenericSkeleton;
